export default "__VITE_ASSET__f5a3c656__"